import template from './rent-part-house.jade';
import rentPartHouseType from './../../../enums/rent-part-house-type';
import validation from '../../../services/validation';

export default angular.module('cian.addForm.rentPartHouse', []).directive('cianAfAboutObjectRentPartHouse', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller(deviceService) {
    'ngInject';

    this.isMobile = deviceService.isMobile;

    this.items = rentPartHouseType;

    this.rentByParts = this.ad.isRentByParts ? 'partly' : 'wholly';

    this.onChangeHandle = function () {
      this.ad.isRentByParts = this.rentByParts === 'partly';
    };

    this.validation = validation(this.form, 'rentByPartsDescription', {
      parse: 'Введите одно из значений по примеру: 25%, 0.25 или 1/4',
      required: 'Введите значение',
      max: 'Доля должна быть меньше 1(100%)',
      min: 'Значение не может быть меньше или равно 0',
    });
  },
  controllerAs: 'rentPartHouse',
  template,
})).name;
